<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="applicationSystemAlarmData"
      style="width: 100.1%;"
    >
      <!-- <template slot-scope="{ row, index }" slot="actions">
        <Button
          type="info"
          size="small"
          @click="detail(row)"
          v-hasPermission="['aiMonitor:applicationSystemAlarm:detail']"
          >{{ $t("smartMonitor.applicationSystemAlert.detail") }}</Button
        >
      </template> -->

      <template slot-scope="{ row, index }" slot="detail">
        <Button
          type="info"
          size="small"
          @click="handleShowDetail(row.alertResources)"
          v-hasPermission="['aiMonitor:applicationSystemAlarm:detail']"
          >{{ $t("smartMonitor.applicationSystemAlert.detail") }}</Button
        >
      </template>
    </Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
    <Modal v-model="showDetailModal" :title="$t('aiMonitor.alertResourceDetail')" footer-hide>
      <div>
        <Table
          :no-data-text="$t('common.noData')"
          :columns="columnsDetail"
          :data="getRow"
          style="width: 100.1%;"
        >
        </Table>
      </div>
    </Modal>
  </div>
</template>
<script>
import TableExpand from "../application_system_alarm/TableExpand.vue";
import utils from "../../../utils/utils.js";
var tableApplicationSystemAlarmVue = {};
export default {
  name: "TableApplicationSystemAlarm",
  components: { TableExpand },
  data() {
    return {
      showDetailModal: false,
      val: "",
      resourceId: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      columnsDetailData: [],
      columnsDetail: [
        {
          title: this.$t('aiMonitor.resourceId'),
          key: "resourceId"
        },
        {
          title: this.$t('aiMonitor.resourceName'),
          key: "resourceName"
        },
        {
          title: this.$t('aiMonitor.metricName'),
          key: "metricName"
        },
        {
          title: this.$t('aiMonitor.threshold'),
          key: "threshold"
        },
        {
          title: this.$t('aiMonitor.currentValue'),
          key: "predictThreshold"
        }
      ],
      columns: [
        // {
        //   type: "expand",
        //   width: 50,
        //   render: (h, params) => {
        //     return h(TableExpand, {
        //       props: {
        //         row: params.row
        //       }
        //     });
        //   }
        // },
        {
          title: this.$t("smartMonitor.applicationSystemAlert.applicationName"),
          key: "applicationName"
        },
        {
          title: this.$t('aiMonitor.alertRuleName'),
          key: "alertRuleName"
        },
        {
          title: this.$t('aiMonitor.alertResourceDetail'),
          key: "",
          slot: "detail"
        },
        {
          title: this.$t("smartMonitor.applicationSystemAlert.caseID"),
          key: "ticketEntityId"
        },
        {
          title: this.$t("smartMonitor.applicationSystemAlert.launchTime"),
          key: "createdTime"
        }
        // {
        //   title: this.$t("smartMonitor.applicationSystemAlert.setIgnorance"),
        //   key: "isIgnore",
        //   render: (h, params) => {
        //     return h("div", [
        //       h(
        //         "i-switch",
        //         {
        //           // 数据库0 enabled,1 disabled
        //           props: {
        //             type: "primary",
        //             size: "large",
        //             value: params.row.isIgnore // 控制开关的打开或关闭状态，官网文档属性是value
        //           },
        //           on: {
        //             "on-change": () => {
        //               this.switch(params.index);
        //             }
        //           }
        //         },
        //         [
        //           h("span", {
        //             slot: "open",
        //             domProps: {
        //               innerHTML: this.$t("common.yes")
        //             }
        //           }),
        //           h("span", {
        //             slot: "close",
        //             domProps: {
        //               innerHTML: this.$t("common.no")
        //             }
        //           })
        //         ]
        //       )
        //     ]);
        //   }
        // },
        // {
        //   title: this.$t("smartMonitor.applicationSystemAlert.operation"),
        //   slot: "actions"
        // }
      ],
      applicationSystemAlarmData: [],
      getRow: []
    };
  },
  beforeCreate: function() {
    tableApplicationSystemAlarmVue = this;
  },
  mounted: function() {
    tableApplicationSystemAlarmVue.getApplicationSystemAlarm();
  },
  methods: {
    handleShowDetail(row) {
      this.getRow = row;
      this.showDetailModal = true;
    },
    /**************************************分页**************************************/
    showAll: function() {
      tableApplicationSystemAlarmVue.getApplicationSystemAlarm();
    },
    // 分页显示数据
    getApplicationSystemAlarm: function() {
      // 获取ApplicationSystemAlarmSearch里面的搜索内容
      eventBus.$on("applicationNameSearchName", function(val) {
        tableApplicationSystemAlarmVue.val = val;
      });
      //分页
      this.$api.aiApplicationAlert
        .pageAiApplicationAlert({
          pageNum: this.current,
          pageSize: this.pageSize,
          applicationName: tableApplicationSystemAlarmVue.val
        })
        .then(res => {
          this.applicationSystemAlarmData = res.data.records;
          // 创建时间
          for (var i = 0; i < this.applicationSystemAlarmData.length; i++) {
            this.applicationSystemAlarmData[
              i
            ].createdTime = utils.methods.formatDate(
              this.applicationSystemAlarmData[i].createdTime
            );
          }
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableApplicationSystemAlarmVue.getApplicationSystemAlarm();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableApplicationSystemAlarmVue.getApplicationSystemAlarm();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("applicationNameSearchName");
    },
    // 详情
    detail: function(row) {
      if (row.resourceTypeName == "数据库") {
        this.$router.push({
          path: "/aiMonitor/databaseDetail/",
          query: { databaseId: row.moduleId }
        });
      }
      if (row.resourceTypeName == "实例") {
        this.$router.push({
          path: "/aiMonitor/instanceDetail/",
          query: { instanceId: row.moduleId }
        });
      }
    },
    /**************************************switch**************************************/
    // switch
    switch(index) {
      this.index = index;
      // 打开是true,启用0 禁用1
      if (this.applicationSystemAlarmData[index].isIgnore) {
        this.changeStatusMessage(
          this.applicationSystemAlarmData[index].id,
          "isIgnore",
          false
        );
      } else {
        this.changeStatusMessage(
          this.applicationSystemAlarmData[index].id,
          "isIgnore",
          true
        );
      }
    },
    // 更新反馈信息某一字段
    changeStatusMessage: function(id, key, value) {
      this.$api.aiApplicationAlert
        .changeStatus({
          id: id,
          isIgnore: value
        })
        .then(res => {
          tableApplicationSystemAlarmVue.getApplicationSystemAlarm();
        });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/application_system_alarm/TableApplicationSystemAlarm.vue